// extracted by mini-css-extract-plugin
module.exports = {"selector":"selector_selector__ucwTc","option":"selector_option__3ExMK"};